import React from "react";
import { addVehicleEffect } from "../../../../stores/VehiclesStore/VehiclesStore.effects";
import { AddButton } from "../../../../components/Table";
import VehicleFormModal from "../VehicleFormModal/VehicleFormModal";

const AddVehicle: React.FC = () => {
  return (
    <VehicleFormModal
      effect={addVehicleEffect}
      title="Adicionar veículo"
      confirmText="Confirmar"
      cancelText="Cancelar"
      TriggerComponent={<AddButton>Adicionar veículo</AddButton>}
    />
  );
};

export default AddVehicle;
